export default function Header({ text }) {
    return (
        <div className='p-5 bg-gray-50 dark:bg-[#222222] dark:text-white'>
            <div className="container mx-auto">
                <span className='font-semibold'>{text}</span>
            </div>
        </div>
    )
}